import React, { useRef } from "react";
import {
  Typography,
  IconButton,
  styled,
  Divider,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import tooltipCalender from "../../assets/images/icons/tooltip-clender.svg";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#EAFFD8",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    background: "#EAFFD8",
    color: "#2B2B2B",
    width: "1000px",
    boxShadow: "4px 20px 36px 8px #1D1D1B14",
    border: "1px solid #164A1A",
    padding: 0,
  },
}));

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(() => ({
  background: "#EAFFD8",
  border: `1px solid #164A1A`,
  "&::before": {
    display: "none",
  },
}));

const AccordionSummary = styled(MuiAccordionSummary)(() => ({
  padding: "1rem",
  backgroundColor: "#EAFFD8",
  "& .MuiTypography-root": {
    fontFamily: "MADE TOMMY",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "17px",
    color: "#2B2B2B",
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(() => ({
  padding: "1rem",
  backgroundColor: "#EAFFD8",
}));

const AccordionContainer = styled("div")(({ shouldScroll }) => ({
  maxHeight: shouldScroll ? "200px" : "auto",
  overflowY: shouldScroll ? "auto" : "visible",
  overflowX: "hidden",

  /* Scrollbar styling for WebKit browsers */
  "&::-webkit-scrollbar": {
    width: "6px",
  },
  "&::-webkit-scrollbar-track": {
    background: "transparent",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#A3B9A5", // muted green-gray
    borderRadius: "10px",
  },

  /* Optional: Firefox scrollbar styling */
  scrollbarColor: "#A3B9A5 transparent",
  scrollbarWidth: "thin",
}));

const InfoDataTooltipAccordion = ({ data }) => {
  const elementRef = useRef(null);

  const readMore = (value) =>
    `${process.env.REACT_APP_ORIGIN}${
      process.env.REACT_APP_ORIGIN.includes("localhost") ? "" : "/"
    }pages/glossary/#${value}`;
 

  const infoData = data?.resources

  return (
    <CustomTooltip
    arrow
    placement="top"
    sx={{ zIndex: 99999999 }}
    title={
      <div>
         <AccordionContainer shouldScroll={infoData?.length > 2}>
          {infoData?.map((resource, index) => (
            
            <Accordion key={index}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`tooltip-accordion-content-${index}`}
                id={`tooltip-accordion-summary-${index}`}
              >
                <Typography sx={{ textTransform: "capitalize"}}>{resource?.caption_text}</Typography>
              </AccordionSummary>
    
              <Divider sx={{ borderColor: "#164A1A" }} />
    
              <AccordionDetails>
                <div style={{ marginBottom: "15px" }}>
                  <Typography
                    sx={{
                      fontFamily: "MADE TOMMY",
                      fontSize: "14px",
                      fontWeight: "500",
                      lineHeight: "14px",
                      paddingBottom: "1rem",
                    }}
                  >
                    Description
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "MADE TOMMY",
                      fontSize: "14px",
                      fontWeight: "400",
                    }}
                  >
                    {resource?.description}
                  </Typography>
                </div>
    
                <div style={{ padding: "0.5rem 0rem" }}>
                  <Typography
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      fontFamily: "MADE TOMMY",
                      color: "#2B2B2B",
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                  >
                    <span>Reporting period</span>
                    <span style={{ display: "flex", alignItems: "center", marginLeft: "1rem" }}>
                      <img
                        src={tooltipCalender}
                        alt="calendar"
                        width="16px"
                        height="16px"
                        style={{ margin: "0 6px" }}
                      />
                      {data?.formatted_timestamp}
                    </span>
                  </Typography>
    
                  <Typography
                    sx={{
                      paddingTop: "10px",
                      fontFamily: "MADE TOMMY",
                      color: "#2B2B2B",
                      fontSize: "13px",
                      fontWeight: "400",
                    }}
                  >
                    {resource?.citation}
                  </Typography>
    
                  {data?.glossary_resource && (
                    <Typography sx={{ marginTop: "1rem" }}>
                      <a
                        href={readMore(data?.glossary_resource)}
                        target="_blank"
                        rel="noreferrer"
                        style={{
                          color: "#164A1A",
                          textDecoration: "underline",
                          fontWeight: 500,
                          fontSize: "14px",
                          fontFamily: "MADE TOMMY",
                        }}
                      >
                        Read more
                      </a>
                    </Typography>
                  )}
                </div>
              </AccordionDetails>
            </Accordion>
          ))}
         </AccordionContainer>
      </div>
    }
  >
    <IconButton
      ref={elementRef}
      disableRipple
      disableFocusRipple
      disableTouchRipple
      aria-owns={`mouse-over-popover`}
      aria-haspopup="true"
      className="my-twelve-step"
    >
      <InfoOutlinedIcon
        sx={{ color: "#919397", marginTop: "-10px" }}
        fontSize="small"
      />
    </IconButton>
  </CustomTooltip>
  );
};

export default InfoDataTooltipAccordion;